import "core-js";
import React, { Component } from "react";

import { withFirebase } from "../Firebase";

import * as ROUTES from "../../constants/routes";
import "react-dates/lib/css/_datepicker.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import moment from "moment";
import "react-dates/initialize";
import {
  DateRangePicker
} from "react-dates";
import {
  Button,
  Card,
  Elevation,
 
} from "@blueprintjs/core";

import { DateRangeInput } from "@blueprintjs/datetime";
import ReactDataGrid from "react-data-grid";

import { Grid, Row, Col } from "react-flexbox-grid";

import { Link } from "react-router-dom";

import "./index.css";

const {
  Toolbar,
  Filters: {
    NumericFilter,
    AutoCompleteFilter,
    MultiSelectFilter,
    SingleSelectFilter
  },
  Data: { Selectors }
} = require("react-data-grid-addons");
const selectors = Selectors;

class Summarization extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      events: [],
      visible_events: [],
      filters: {},
      selectedIndexes: [],
      selectedEvents: [],
      rows: "",
      focusedInput: undefined,
      startDate: moment().subtract(1, "week"),
      endDate: moment().add(1, "week")
    };
  }

  componentDidMount() {
    var local_events = [];
    this.props.firebase.events().onSnapshot(snapshot => {
      snapshot.forEach(doc => {
        try {
          var event_object = doc.data();
          event_object.id = doc.id;
          this.props.firebase.getRef(event_object.instructor).then(doc => {
            try {
              event_object.owner_name = doc.data().name;
            } catch (err) {
              console.log(err);
              event_object.owner_name = "undefined";
            }
            local_events.push(event_object);
            this.setState({
              events: local_events,
              visible_events: this.rows(local_events)
            });
          });
        } catch (err) {
          console.log(err);
        }
      });
    });
  }

  getRegisteredCount() {
    var events = this.getRows(this.state.visible_events, this.state.filters);
    var i = 0;
    events.forEach(row => {
      if (row.registered !== "not available") {
        i += row.registered;
      }
    });
    return i;
  }

  getAttendedCount() {
    var events = this.getRows(this.state.visible_events, this.state.filters);
    var i = 0;
    events.forEach(row => {
      if (row.attended !== "not available") {
        i += row.attended;
      }
    });
    return i;
  }

  getWaitlistCount() {
    var events = this.getRows(this.state.visible_events, this.state.filters);
    var i = 0;
    events.forEach(row => {
      if (row.waitlist !== "not available") {
        i += row.waitlist;
      }
    });
    return i;
  }

  getWalkCount() {
    var events = this.getRows(this.state.visible_events, this.state.filters);
    var i = 0;
    events.forEach(row => {
      if (row.walk_in !== "not available") {
        i += row.walk_in;
      }
    });
    return i;
  }

  itemRenderer = (bool, event) => {
    //console.log(bool, event);
  };

  onItemSelect = event => {
    //console.log(event);
  };

  handleGridSort(sortColumn, sortDirection) {
    const comparer = (a, b) => {
      if (sortColumn === "registration_date") {
        var aSplit = a[sortColumn].split(".");
        var aDate = new Date(aSplit[2], aSplit[1] - 1, aSplit[0]);
        var aValue = aDate.valueOf();

        var bSplit = b[sortColumn].split(".");
        var bDate = new Date(bSplit[2], bSplit[1] - 1, bSplit[0]);
        var bValue = bDate.valueOf();
      }

      if (sortDirection === "ASC") {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.rows(this.state.events).slice(0)
        : this.state.rows.sort(comparer);
    this.setState({ rows: rows });
  }

  handleFilterChange(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  }

  getValidFilterValues(columnId) {
    let values = this.state.visible_events.map(r => r[columnId]);
    return values.filter((item, i, a) => {
      return i === a.indexOf(item);
    });
  }

  getRows(rows, filters) {
    return selectors.getRows({ rows, filters });
  }

  handleClearFilters = () => {
    this.setState({ filters: Object.assign({}) });
  };

  onRowsSelected = users => rows => {
    this.setState({
      selectedIndexes: this.state.selectedIndexes.concat(
        rows.map(r => r.rowIdx)
      ),
      selectedEvents: this.state.selectedEvents.concat(
        rows.map(r => users[r.rowIdx].id)
      )
    });
  };

  onRowsDeselected = users => rows => {
    let rowIndexes = rows.map(r => r.rowIdx);
    let users_email = rows.map(r => users[r.rowIdx].id);
    this.setState({
      selectedIndexes: this.state.selectedIndexes.filter(
        i => rowIndexes.indexOf(i) === -1
      ),
      selectedEvents: this.state.selectedEvents.filter(
        i => users_email.indexOf(i) === -1
      )
    });
  };

  cols = [
    {
      key: "name",
      name: "Name",
      width: 150,
      filterRenderer: SingleSelectFilter,
      formatter: this.confirme_formatter,
      resizable: true,
      sortable: false,
      filterable: true,
      frozen: true
    },
    {
      key: "id",
      name: "ID",
      width: 100,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: false,
      filterable: true,
      frozen: true
    },
    {
      key: "instructor",
      name: "Instructor",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true
    },

    {
      key: "owner",
      name: "Owner",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },
    {
      key: "program",
      name: "Program",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },

    {
      key: "type",
      name: "Type",
      width: 150,
      filterRenderer: AutoCompleteFilter,
      resizable: true,
      sortable: true,
      filterable: true,
      frozen: false
    },

    {
      key: "date",
      name: "Date",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_date_formatter,
      resizable: true,
      sortable: true,
      filterable: true
    },
    {
      key: "registered",
      name: "Registered",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_formatter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "attended",
      name: "Attended",
      width: 100,
      filterRenderer: SingleSelectFilter,
      formatter: this.boolean_date_formatter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "walk_in",
      name: "Walk-In",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "waitlist",
      name: "Waitlist",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    },
    {
      key: "stream_views",
      name: "Stream Views",
      width: 100,
      filterRenderer: MultiSelectFilter,
      resizable: true,
      sortable: false,
      filterable: false
    }
  ];

  getAttended = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.attended) {
        i++;
      }
    });
    return i;
  };
  getRegistrations = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.confirmed) {
        i++;
      }
    });
    return i;
  };
  getWalkIn = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.walk_in) {
        i++;
      }
    });
    return i;
  };
  getWaitlist = registrations => {
    var i = 0;
    registrations.forEach(registration => {
      if (registration.waitlist) {
        i++;
      }
    });
    return i;
  };
  rows = events => {
    var list = [];
    events.forEach(event => {
      try {
        let eventDateJS = new Date(event.event_date[0].date.seconds * 1000);
        let eventDate = moment(eventDateJS);
        console.log(eventDate.format("LLLL"));
        if (this.state.startDate !== undefined) {
          if (
            eventDate >= this.state.startDate &&
            eventDate <= this.state.endDate
          ) {
            var row = {
              id: event.id === undefined ? "not available" : event.id,
              owner:
                event.owner_name === undefined
                  ? "not available"
                  : event.owner_name,
              program:
                event.program === undefined ? "not available" : event.program,
              name:
                event.event_name === undefined
                  ? "not available"
                  : event.event_name,
              type:
                event.event_type === undefined
                  ? "not available"
                  : event.event_type,
              instructor:
                event.owner_name === undefined
                  ? "not available"
                  : event.owner_name,
              date:
                event.event_date[0] === undefined
                  ? "not available"
                  : new Date(
                      event.event_date[0].date.seconds * 1000
                    ).toLocaleDateString(),
              registered:
                event.registrations === undefined
                  ? event.num_registered
                  : this.getRegistrations(event.registrations),
              attended:
                event.registrations === undefined
                  ? event.num_attended
                  : this.getAttended(event.registrations),
              walk_in:
                event.registrations === undefined
                  ? "not available"
                  : this.getWalkIn(event.registrations),
              waitlist:
                event.registrations === undefined
                  ? "not available"
                  : this.getWaitlist(event.registrations),
              stream_views: "feature not yet implemented",
              check_in: (
                <Link to={`/checkin/${event.id}`}>
                  <Button fill={true} text="Check-In" />
                </Link>
              ),
            };
            list.push(row);
          }
        }
      } catch (err) {
        console.log(err);
      }
    });
    return list;
  };
  render() {
    var { visible_events, filters } = this.state;
    var filteredRows = this.getRows(visible_events, filters);
    return (
      <Grid>
        <h1>Events</h1>
        <Row>
          <DateRangePicker
            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
            onDatesChange={({ startDate, endDate }) => {
              this.setState({ startDate, endDate });
              this.componentDidMount();
            }} // PropTypes.func.isRequired,
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={(focusedInput) => this.setState({ focusedInput })} // PropTypes.func.isRequired,
            isOutsideRange={() => false}
          />
        </Row>
        <Row>
          <Col xs>
            <ReactDataGrid
              columns={this.cols}
              rowGetter={(i) => filteredRows[i]}
              rowsCount={this.state.visible_events.length}
              toolbar={<Toolbar enableFilter={true} />}
              onGridSort={(sortColumn, sortDirection) =>
                this.handleGridSort(sortColumn, sortDirection)
              }
              onAddFilter={(filter) => this.handleFilterChange(filter)}
              getValidFilterValues={(colId) => this.getValidFilterValues(colId)}
              onClearFilters={() => this.handleClearFilters()}
              rowSelection={{
                showCheckbox: false,
                enableShiftSelect: false,
                onRowsSelected: this.onRowsSelected(this.state.events),
                onRowsDeselected: this.onRowsDeselected(this.state.events),
                selectBy: {
                  indexes: this.state.selectedIndexes,
                },
              }}
            />
          </Col>
          <Col xs>
            <Card interactive={false} elevation={Elevation.TWO}>
              <h5 style={{ fontSize: 15 }}>Total Events </h5>
              <Row xs>
                <p>Events:</p> {filteredRows.length}
              </Row>
              <h5 style={{ fontSize: 15 }}>Total Users</h5>
              <Row xs>
                <p>Registered:</p> {this.getRegisteredCount()}
              </Row>
              <Row xs>
                <p>Attended:</p> {this.getAttendedCount()}
              </Row>
              <Row xs>
                <p>Walk-ins:</p> {this.getWalkCount()}
              </Row>
              <Row xs>
                <p>Waitlists:</p> {this.getWaitlistCount()}
              </Row>
            </Card>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default withFirebase(Summarization);
